import { isSomething } from "../utils/langUtils";

const BREADCRUMP_SEPARATOR = "-";

export function extractNodeType(rawNodeType: $TSFixMe) {
  const tenantId = rawNodeType.tenant ? rawNodeType.tenant.id : undefined;
  const tenantName = rawNodeType.tenant ? rawNodeType.tenant.name : undefined;
  const tenantPublic = rawNodeType.tenant
    ? rawNodeType.tenant.public
    : undefined;

  return {
    id: rawNodeType.id,
    name: rawNodeType.name,
    code: rawNodeType.code,
    tenantId,
    tenantPublic,
    tenantName,
    parentId: rawNodeType.parent ? rawNodeType.parent.id : null,
    parentCode: rawNodeType.parent ? rawNodeType.parent.code : null,
  };
}

// @ts-expect-error TS(7023) FIXME: 'buildDisplayNameForTree' implicitly has return ty... Remove this comment to see the full error message
function buildDisplayNameForTree(type: $TSFixMe) {
  if (isSomething(type.parent)) {
    return `${buildDisplayNameForTree(type.parent)} ${BREADCRUMP_SEPARATOR} ${type.name}`;
  }
  return type.name;
}

// @ts-expect-error TS(7023) FIXME: 'buildDisplayName' implicitly has return type 'any... Remove this comment to see the full error message
function buildDisplayName(type: $TSFixMe, allTypes: $TSFixMe) {
  if (isSomething(type.parentId)) {
    const parent = allTypes.find((t: $TSFixMe) => t.id === type.parentId);
    if (parent.parentId) {
      return `${buildDisplayName(parent, allTypes)} ${BREADCRUMP_SEPARATOR} ${type.name}`;
    }
    return `${parent.name} ${BREADCRUMP_SEPARATOR} ${type.name}`;
  }
  return type.name;
}

export function extractNodeTypes(
  rawTypes: $TSFixMe,
  buildBreadcrumbNames = false,
) {
  const mappedTypes = rawTypes.node_types.map((type: $TSFixMe) =>
    extractNodeType(type),
  );
  if (buildBreadcrumbNames) {
    mappedTypes.forEach((type: $TSFixMe) => {
      /* eslint-disable no-param-reassign */
      type.name = buildDisplayName(type, mappedTypes);
    });
  }
  return mappedTypes;
}

export function extractNodeTypeTree(rawNodeType: $TSFixMe) {
  const type = extractNodeType(rawNodeType);
  type.name = buildDisplayNameForTree(rawNodeType);
  return type;
}
